export default __webpack_public_path__ + "static/media/Contemporary.d4c0697f.jpg";